import PropTypes from 'prop-types';
import { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isNull } from 'lodash';
import {
  tourSearchRequest,
} from '../../../../store/slices/tripSearch';
import ErrorTooltip from '../../../ErrorTooltip';
import TourStartDateFilter from '../TourFilterBar/TourDateFilter/TourStartDateFilter';
import TourEndDateFilter from '../TourFilterBar/TourDateFilter/TourEndDateFilter';
import TourDestinationFilter from '../TourFilterBar/TourDestinationFilter';

const TourSearchBar = ({ tripId }) => {
  const dispatch = useDispatch();
  const [doOpenTourStartDate, setDoOpenTourStartDate] = useState(false);
  const [doOpenTourEndDate, setDoOpenTourEndDate] = useState(false);
  const initialFormValidations = { startDate: null, endDate: null, destinations: null };
  const [formValidations, setFormValidations] = useState(initialFormValidations);
  const { searchInputs } = useSelector((store) => store.tripSearch);

  const handleOpenFirstDatePicker = (val) => {
    setDoOpenTourStartDate(val);
    if (!val) {
      setTimeout(() => { setDoOpenTourEndDate(true); }, 50);
    }
  };

  useEffect(() => {
    if (doOpenTourStartDate) setDoOpenTourEndDate(false);
  }, [doOpenTourStartDate]);

  const validateSearch = (obj, doShowValidationErrors = true) => {
    const validationObj = { ...initialFormValidations };
    let isValid = true;
    if (!obj) return false;
    if (!obj.startDate) {
      validationObj.checkInDate = 'Start date is required.';
      isValid = false;
    } else if (!obj.endDate) {
      validationObj.checkOutDate = 'End date is required.';
      isValid = false;
    } else if (obj.destinations.length < 1) {
      validationObj.destinations = 'Destination is required';
      isValid = false;
    }
    if (doShowValidationErrors) setFormValidations(validationObj);
    return isValid;
  };

  const handleSearch = (event, doShowValidationErrors = true) => {
    if (event) event.preventDefault();
    if (validateSearch(searchInputs.tour, doShowValidationErrors)) {
      dispatch(tourSearchRequest({ isTripSearch: false }));
    }
  };

  const handleResetValidation = () => {
    setFormValidations(initialFormValidations);
  };

  return (
    <form onSubmit={handleSearch} onFocus={handleResetValidation}>
      <div className="mt-2 p-2 bord">
        <div className="flex gap-2 flex-wrap text-theme">
          <ErrorTooltip
            title={formValidations.destinations || ''}
            open={!isNull(formValidations.destinations)}
            arrow
          >
            <div className="xl:col-span-4 col-span-4">
              <TourDestinationFilter tripId={tripId} />
            </div>
          </ErrorTooltip>
          <ErrorTooltip
            title={formValidations.checkInDate || ''}
            open={!isNull(formValidations.checkInDate)}
            arrow
          >
            <div className="xl:col-span-2 col-span-3">
              <TourStartDateFilter
                doOpenDatePicker={doOpenTourStartDate}
                setDoOpenDatePicker={handleOpenFirstDatePicker}
                tripId={tripId}
              />
            </div>
          </ErrorTooltip>
          <ErrorTooltip
            title={formValidations.checkOutDate || ''}
            open={!isNull(formValidations.checkOutDate)}
            arrow
          >
            <div className="xl:col-span-2 col-span-3">
              <TourEndDateFilter
                doOpenDatePicker={doOpenTourEndDate}
                setDoOpenDatePicker={setDoOpenTourEndDate}
                tripId={tripId}
              />
            </div>
          </ErrorTooltip>
          <div>
            <button
              type="submit"
              className="px-8 min-h-12 h-auto bg-searchButton-0 text-white text-base font-bold h-full w-max rounded-2xl"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

TourSearchBar.propTypes = {
  tripId: PropTypes.string,
};

TourSearchBar.defaultProps = {
  tripId: undefined,
};

export default memo(TourSearchBar);
